var _circle, _path, _path2, _circle2, _circle3, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#E5E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 72C74.2386 72 72 74.2386 72 77V88V149V162C72 164.761 74.2386 167 77 167H183.725C186.591 167 188.871 164.595 188.718 161.733L184.754 87.7326C184.611 85.0789 182.418 83 179.761 83H152.044L150.563 75.9694C150.076 73.6559 148.035 72 145.671 72H112.375H77Z",
    fill: "#8C9EB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 81C69.2386 81 67 83.2386 67 86V97V169V179C67 181.761 69.2386 184 72 184H184C186.761 184 189 181.761 189 179V97C189 94.2386 186.761 92 184 92H147.602L145.911 84.849C145.377 82.5932 143.363 81 141.045 81H109.5H72Z",
    fill: "#BACBDB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.28,
    cy: 126.28,
    r: 5.28,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.72,
    cy: 126.28,
    r: 5.28,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134 149C130.123 145 124.877 145 121 149",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFile);
export default __webpack_public_path__ + "static/media/empty_file.9fd3fca7.svg";
export { ForwardRef as ReactComponent };